// removed by extract-text-webpack-plugin
module.exports = {"main":"gN3r0idC"};